import React from "react"
import "./WebDevelopment.css"
import "./general.css"
//import { online } from "../../dummydata"
//import { FaEdgeLegacy } from "react-icons/fa";

const WebDevelopment = () => {
  return (
    <>
   <div className="section home wf-section webdev">
    <div className="flex-container flex-on-tablet w-container">
      <div className="text-content light narrow">
       <h1 className="first-title white">Website Development</h1>
     </div>

     <div className=" non-hide">
      <div className="container" id="request">
        

        </div>
      </div>
    </div>
  </div>
   


<div className="page-wrap">
  <div className="section wf-section">
    <div className="course-columns">
      <div className="sticky-column">
        <div className="nav-holder"><a href="#introduction" className="course-nav-button w-inline-block t-content">
          <div>Introduction</div>
          </a><a href="#program" className="course-nav-button w-inline-block t-content">
          <div>Program Summary</div>
          </a><a href="#career" className="course-nav-button w-inline-block t-content">
          <div>Career Opportunities</div>
          </a><a href="#requirements" className="course-nav-button w-inline-block t-content">
          <div>Course Content</div>
          </a><a href="#course_content" className="course-nav-button w-inline-block t-content">
          <div>Requirements</div>
         
          </a></div>
        <a href="/apply-web-development" className="button full-width top-padding w-button c-buuton">APPLY NOW</a>
      </div>
      

      <div className="course-content">
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Program Highlights</h2>
            <ul>
                 <li><span class="semi-bold offset-padding">Course Curriculum :</span> <span class="bold">Certificate Program</span></li>

                <li><span className="semi-bold offset-padding">Duration :</span><span className="bold"> 3 Months</span></li>
                <li><span className="semi-bold offset-padding">Format :</span><span className="bold"> (Online/ In- person) </span></li>
                <li><span className="semi-bold offset-padding">Center :</span> <span className="bold"> Tema Mataheko</span> </li>
            </ul>
          </div>
        </div>
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Introduction</h2>
			<p className="paragraph-2">Website development is the process of creating and maintaining websites. It involves a variety of skills,including coding, design, and web architecture. In a website development course, you can expect to learn the fundamental building blocks of web development, such as HTML, CSS, and JavaScript.</p>
			<p className="paragraph-2">In the Website Development Course, We will be using React Js, a powerful and popular library for building dynamic and interactive web applications. React.js is a popular JavaScript library for building user interfaces. It was developed by Facebook and is widely used for creating interactive and dynamic web applications.</p>
			<p className="paragraph-2">Overall, In this website development course, we can provide you with the skills and knowledge needed to create professional and effective websites that meet the needs of users and businesses alike.</p>
	
            
			</div>
        </div>
      
        <div id="program" className="group">
          <div className="text-content centered">
            <h2 className="second-title">Program Summary</h2>
            <p className="paragraph">
				<ul>
					<li className="">Overview of web development concepts.</li>
					<li className="">Introduction to HTML, CSS, and JavaScript.</li>
					<li className="">Understanding the React.js library and its core principles.</li>
					<li className="">Building Full-Stack Applications with Express</li>
					<li className="">Overview of Node.js and its role in web development</li>
					<li className="">Designing RESTful APIs and understanding REST principles</li>
					<li className="">Implementing CRUD operations using Express.js and MongoDB.</li>
				</ul>
			</p>
			<p>If you are new to IT and wish to create professional websites for business or brands, this is the course for you.</p>
          </div>
        </div>
        
        <div id="career" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Career Opportunities</h2>
            <p className="paragraph">
			<ul>
        <li>Full-stack Developer</li>
				<li>Front-end Developer</li>
				<li>Back-end Developer</li>
				
			</ul>
            </p>
           
          </div>
        </div>
        <div id="course_content" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Course Content</h2>
            <p className="paragraph">
            <div className="container inner_content_block2" id="inner_content_block2">

				<div className="row margin-bottom30 ">
					<div className="col-md-6 ">
						<ul>
						<li>Introduction to HTML, CSS, and JavaScript</li>
						<li>Setting up the development environment (IDE, code editor, browser)</li>
						<li>Understanding the React.js library and its core principles</li>
						<li>Setting up a React.js project</li>
						<li>React components and JSX syntax</li>
						<li>State and props in React components</li>
						</ul>
					</div>
					<div className="col-md-6">
						<ul>
							<li>Handling events and user interactions in React components</li>
							<li>Creating forms and handling form submissions in React.js</li>
							<li>Working with front end libraries (Material UI, Bootstrap)</li>
							<li>Setting up Node.js and Express.js</li>
							<li>Designing RESTful APIs and understanding REST principles</li>
							<li>Implementing CRUD operations using Express.js and MongoDB</li>
						</ul>
					</div>
				</div>
				
				
			</div>
			</p>
          </div>
        </div>
		
        <div id="requirements" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Eligibility Requirements</h2>
			<ul>
				<li>Minimum of Basic Education Certificate</li>
			</ul>
           
        </div>
        <div id="admissions" className="group ">
          
          <a href="/apply-web-development" className="button full-width top-padding w-button c-buuton">APPLY NOW</a></div>
        </div>
      </div>
    </div>
  </div>
</div>

            
    </>
  )
}

export default WebDevelopment;
